<!-- eslint-disable vue/no-v-html -->
<template>
  <div
    ref="modal"
    class="modal fade"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div
      class="modal-dialog"
      :class="getCSSClassSizeModal()"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h5 :class="'modal-title ' + titleClass">
            <div v-if="Array.isArray(title)">
              <span
                v-for="(item, index) in title"
                :key="index"
              >
                {{ item }} <br>
              </span>
            </div>

            <div
              v-else
              v-html="title"
            />
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          />
        </div>
        <div :class="'modal-body ' + bodyClass">
          <div v-if="Array.isArray(content)">
            <div
              v-for="(item, index) in content"
              :key="index"
              v-html="item"
            />
          </div>
          <div
            v-else
            v-html="content"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
	export default {
		name: 'Modal',
		props: {
			title: {
				type: [String, Array],
				default: ''
			},
			content: {
				type: [String, Array],
				default: ''
			},
			isOpen: {
				type: Boolean,
				required: true
			},
			/**
			 * Size of the modal:
			 * - 0: Small - 300px - model-sm
			 * - 1: Default - 500px
			 * - 2: Large - 800px - modal-lg
			 * - 3: Extra Large - 1140px - modal-xl
			 */
			size: {
				type: Number,
				default: 1
			},
			titleClass: {
				type: String,
				default: '',
			},
			bodyClass: {
				type: String,
				default: '',
			},
		},
		data() {
			return {
				modal: null,
			}
		},
		watch: {
			isOpen(newValue) {
				if (newValue === true) {
					this.openModal()
				}
				if (newValue === false) {
					this.closeModal()
				}
			},
		},
		mounted() {
			const modalElement = this.$refs['modal']
			this.modal = new window.bootstrap.Modal(modalElement)
			modalElement.addEventListener('hidden.bs.modal', (event) => {
				event.preventDefault()
				this.$emit('onClose')
			})
		},
		destroyed() {
			this.modal.dispose()
		},
		methods: {
			openModal() {
				this.modal.show()
			},
			closeModal() {
				this.modal.hide()
			},
			getCSSClassSizeModal() {
				switch (this.size) {
					case 0:
					return 'modal-sm'
					case 2:
					return 'modal-lg'
					case 3:
					return 'modal-xl'
					default:
					return ''
				}
			},
		},
	}
</script>

<style lang="scss" scoped>
	.large-content {
	width: 1000px !important;
	margin-left: -250px !important;
	}
</style>
